export default [
  {
    name: 'Faxes Inbox',
    path: '/fax-inbox/:id?',
    component: () => import(/* webpackChunkName: "faxing" */ '@/views/faxing/FaxInboxView.vue')
  },
  {
    name: 'Faxes Outbox',
    path: '/fax-outbox/:id?',
    component: () => import(/* webpackChunkName: "faxing" */ '@/views/faxing/FaxOutboxView.vue')
  },
  {
    name: 'Faxes Archive',
    path: '/fax-archive/:id?',
    component: () => import(/* webpackChunkName: "faxing" */ '@/views/faxing/FaxArchiveView.vue')
  },
  {
    name: 'Import Fax Patient',
    path: '/import-fax-patient',
    component: () => import(/* webpackChunkName: "faxing" */ '@/views/faxing/ImportFaxPatientView.vue')
  }
]